import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { VendorHero } from '../../components/inner/venderProduct/vendorUi'

import p02 from '../../assets/technologies/delfort/delfort_p02.png'
import p04 from '../../assets/technologies/delfort/delfort_p04.png'
import p05 from '../../assets/technologies/delfort/delfort_p05.png'
import p06 from '../../assets/technologies/delfort/delfort_p06.png'
import p08 from '../../assets/technologies/delfort/delfort_p08.png'
import p09 from '../../assets/technologies/delfort/delfort_p09.png'
import p15 from '../../assets/technologies/delfort/delfort_p15.png'

const Delfort = () => {
  return (
    <Page>
      {/* 1) Hero */}
      <VendorHero
        title="Delfort IonPort®"
        subtitle="섬유 기반(셀룰로스) 분리막 솔루션 — 슈퍼커패시터·이차전지·전고체전지용"
      />

      <Main>
        {/* 2) 벤더 소개 */}
        <Split $imageRight>
          <Media>
            <SectionImage src={p02} alt="Delfort company overview" />
          </Media>
          <Text>
            <Eyebrow>Vendor</Eyebrow>
            <SectionTitle>Delfort — 특수제지 기반 소재 파트너</SectionTitle>
            <BulletList>
              <li>오스트리아 본사의 특수제지 전문 제조사로, 다양한 산업에 소재를 공급합니다.</li>
              <li>유럽·미주·아시아에 걸친 글로벌 생산·판매망을 보유하고 있습니다.</li>
              <li>임직원 약 3,200명, 2025년 매출 €12억 규모입니다.</li>
              <li>특허 700건 이상, grade 1,500여 종을 보유하며 분리막은 오스트리아에서 자체 생산합니다.</li>
            </BulletList>
          </Text>
        </Split>

        {/* 3) 지속가능성·인증 */}
        <Split>
          <Media>
            <SectionImage src={p04} alt="Delfort sustainability & certifications" />
          </Media>
          <Text>
            <Eyebrow>Sustainability</Eyebrow>
            <SectionTitle>지속가능성과 글로벌 인증</SectionTitle>
            <BulletList>
              <li>UN Global Compact에 가입했으며, SBTi를 통해 넷제로 목표를 검증받았습니다.</li>
              <li>EcoVadis 플래티넘 등급을 5년 연속 획득했습니다.</li>
              <li>CDP 2025 트리플A를 달성했습니다. (전 세계 23개사에 불과)</li>
            </BulletList>
          </Text>
        </Split>

        {/* 4) 제품 개요 */}
        <Split $imageRight>
          <Media>
            <SectionImage src={p05} alt="cellulose separator manufacturing process" />
          </Media>
          <Text>
            <Eyebrow>Technology</Eyebrow>
            <SectionTitle>셀룰로스 분리막의 원리</SectionTitle>
            <BulletList>
              <li>원재료(셀룰로스 + 기능성 섬유 + 첨가제)를 선정합니다.</li>
              <li>섬유 처리 단계에서 수계·혼합·피브릴화 공정을 거칩니다.</li>
              <li>습식 초지 공정으로 웹 형성 → 압착·건조 → 캘린더링을 진행합니다.</li>
              <li>약 5µm 섬유가 만드는 다공 구조로 이온 이동을 최적화합니다.</li>
            </BulletList>
          </Text>
        </Split>

        {/* 5) 제품 포트폴리오 */}
        <Stack>
          <Eyebrow>Portfolio</Eyebrow>
          <SectionTitle>IonPort® 제품 포트폴리오</SectionTitle>
          <SectionImage src={p06} alt="IonPort portfolio at a glance" />
          <TableWrap>
            <Table>
              <thead>
                <tr>
                  <th>라인</th>
                  <th>적용 분야</th>
                  <th>전해질</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>BA</b></td>
                  <td>이차전지 (LIB · SIB · AZIB 등)</td>
                  <td>유기 전해질 · 이온성 액체</td>
                </tr>
                <tr>
                  <td><b>AQ</b></td>
                  <td>수계 이차전지</td>
                  <td>수계 전해질</td>
                </tr>
                <tr>
                  <td><b>SC</b></td>
                  <td>슈퍼커패시터 (EDLC)</td>
                  <td>유기 전해질</td>
                </tr>
                <tr>
                  <td><b>NX</b></td>
                  <td>전고체전지 (SSB)</td>
                  <td>고분자 · 황화물 · 산화물 전해질</td>
                </tr>
              </tbody>
            </Table>
          </TableWrap>
        </Stack>

        {/* 6) 핵심 이점 */}
        <Stack>
          <Eyebrow>Benefits</Eyebrow>
          <SectionTitle>핵심 이점</SectionTitle>
          <SectionImage src={p08} alt="IonPort key benefits" />
          <CardRow>
            <Card>
              <CardTitle>낮은 자기방전</CardTitle>
              <CardText>저항 특성을 최적화하여 자기방전을 억제합니다.</CardText>
            </Card>
            <Card>
              <CardTitle>빠른 충전 · 낮은 ESR</CardTitle>
              <CardText>낮은 굴곡도로 이온 이동을 도와 빠른 충전과 낮은 ESR을 구현합니다.</CardText>
            </Card>
            <Card>
              <CardTitle>높은 에너지밀도</CardTitle>
              <CardText>박형 구조로 셀 내 활물질 비중을 높여 에너지밀도를 향상합니다.</CardText>
            </Card>
          </CardRow>
        </Stack>

        {/* 7) 기술 파라미터 */}
        <Split>
          <Media>
            <SectionImage src={p09} alt="technical parameters" />
          </Media>
          <Text>
            <Eyebrow>Parameters</Eyebrow>
            <SectionTitle>기술 파라미터</SectionTitle>
            <BulletList>
              <li>기공 크기, 굴곡도, 밀도/기공률, 두께가 성능을 좌우하는 핵심 인자입니다.</li>
              <li>이 인자들은 ESR과 MacMullin 수에 직접적인 영향을 줍니다.</li>
            </BulletList>
          </Text>
        </Split>

        {/* 8) 적용 분야 */}
        <Stack>
          <Eyebrow>Applications</Eyebrow>
          <SectionTitle>적용 분야</SectionTitle>
          <ChipRow>
            <Chip>슈퍼커패시터 (EDLC)</Chip>
            <Chip>리튬 · 소듐 · 아연이온 이차전지</Chip>
            <Chip>전고체전지</Chip>
          </ChipRow>
        </Stack>
      </Main>

      {/* 9) 문의 CTA */}
      <Cta>
        <CtaOverlay />
        <CtaInner>
          <CtaTitle>상세 스펙 · 샘플 문의는 라세스로</CtaTitle>
          <CtaButton to="/contact">문의하기</CtaButton>
        </CtaInner>
      </Cta>
    </Page>
  )
}

const Page = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  color: ${({ theme }) => theme.COLOR.BLACK};
`

/* ---------- Main / Sections ---------- */
const Main = styled.div`
  padding: 80px 13%;
  display: flex;
  flex-direction: column;
  gap: 80px;

  @media (max-width: 1200px) {
    padding: 64px 8%;
    gap: 64px;
  }

  @media (max-width: 900px) {
    padding: 48px 24px;
    gap: 56px;
  }
`

const Split = styled.section`
  display: flex;
  flex-direction: ${({ $imageRight }) => ($imageRight ? 'row-reverse' : 'row')};
  align-items: center;
  gap: 48px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 24px;
    align-items: stretch;
  }
`

const Media = styled.div`
  flex: 1 1 0;
  min-width: 0;
`

const Text = styled.div`
  flex: 1 1 0;
  min-width: 0;
`

const Stack = styled.section`
  display: flex;
  flex-direction: column;
`

const SectionImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 14px;
  border: 1px solid rgba(62, 126, 219, 0.16);
  box-shadow: 0 14px 34px rgba(15, 23, 66, 0.12);
`

const Eyebrow = styled.div`
  color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  font-size: ${({ theme }) => theme.SIZE.SMALL};
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 12px;
`

const SectionTitle = styled.h2`
  margin: 0 0 20px;
  font-size: ${({ theme }) => theme.SIZE.X05LARGE};
  font-weight: 600;
  line-height: 1.3;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.XLARGE};
  }
`

const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  line-height: 1.75;
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};

  & > li {
    margin-bottom: 10px;
  }

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM};
  }
`

/* ---------- Portfolio table ---------- */
const TableWrap = styled.div`
  margin-top: 28px;
  width: 100%;
  overflow-x: auto;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};

  th, td {
    text-align: left;
    padding: 14px 18px;
    border-bottom: 1px solid ${({ theme }) => theme.COLOR.RIGHTGRAY};
  }

  thead th {
    background-color: rgba(62, 126, 219, 0.08);
    color: ${({ theme }) => theme.COLOR.DARKBLUE};
    font-weight: 700;
    white-space: nowrap;
  }

  tbody td:first-child {
    color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
    white-space: nowrap;
  }

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM};
    th, td { padding: 12px 14px; }
  }
`

/* ---------- Benefit cards ---------- */
const CardRow = styled.div`
  margin-top: 28px;
  display: flex;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`

const Card = styled.div`
  flex: 1 1 0;
  background-color: #f5f8fd;
  border: 1px solid rgba(62, 126, 219, 0.16);
  border-radius: 14px;
  padding: 24px;
`

const CardTitle = styled.div`
  color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  font-size: ${({ theme }) => theme.SIZE.LARGE};
  font-weight: 700;
  margin-bottom: 10px;
`

const CardText = styled.div`
  line-height: 1.65;
  font-size: ${({ theme }) => theme.SIZE.MEDIUM};
`

/* ---------- Application chips ---------- */
const ChipRow = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
`

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 12px 22px;
  border-radius: 999px;
  background-color: #f5f8fd;
  border: 1px solid rgba(62, 126, 219, 0.28);
  color: ${({ theme }) => theme.COLOR.DARKBLUE};
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  font-weight: 600;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.MEDIUM};
  }
`

/* ---------- CTA ---------- */
const Cta = styled.section`
  position: relative;
  width: 100%;
  min-height: 320px;
  background-image: url(${p15});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    min-height: 260px;
  }
`

const CtaOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(4, 8, 24, 0.62);
`

const CtaInner = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 24px;
`

const CtaTitle = styled.h2`
  margin: 0 0 24px;
  color: ${({ theme }) => theme.COLOR.WHITE};
  font-size: ${({ theme }) => theme.SIZE.X05LARGE};
  font-weight: 700;

  @media (max-width: 900px) {
    font-size: ${({ theme }) => theme.SIZE.XLARGE};
  }
`

const CtaButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 14px 40px;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.COLOR.MAGORELLEBLUE};
  color: ${({ theme }) => theme.COLOR.WHITE};
  font-size: ${({ theme }) => theme.SIZE.MEDIUM2};
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, background-color 0.18s ease;

  &:hover {
    background-color: ${({ theme }) => theme.COLOR.DARKBLUE};
    transform: translateY(-2px);
  }
`

export default Delfort
